/**
 * @description: 关卡管理
 * @author: hwx
 * @update: lyr
*/
<template>
    <div class="level-manage">
        <div class="list-tit" v-show="showTit">
            <ul class="clearfix">
                <li class="col-md-3" v-for="menuItem in menu" :key="menuItem.id">
                    <span class="col-md-10" @click="titClk(menuItem.id)">{{menuItem.name}}</span>
                </li>
            </ul>
        </div>
        <div class="list-con" v-show="!showTit">
            <!-- 主题类型设置 -->
            <div class="zls-list" v-show="show1 && !showZlsEdit">
                <el-row>
                    <el-button class="jh-width130" @click="backFun">返回</el-button>
                </el-row>
                <h1>主题类型设置</h1>
                <el-row>
                    <el-button type="primary" class="pull-right" @click="zlsAdd">新增主题</el-button>
                </el-row>
                <el-table
                    v-loading="loading"
                    element-loading-text="努力加载中，请稍后..."
                    element-loading-background="rgba(0, 0, 0, 0.6)"
                    :data="zls_table">
                    <el-table-column prop="name" label="名称"></el-table-column>
                    <el-table-column prop="person_str" label="人物">
                        <template slot-scope="scope">
                            {{scope.row.person.length > 5 ? scope.row.person_str.split(',').slice(0, 5).join(',') + '...' : scope.row.person_str}}
                        </template>
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <span class="text-blue" @click="zlsModify(scope.row)">修改</span>
                            <span class="text-blue" @click="zlsDel(scope.row.id)">删除</span>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                    background
                    layout="total, prev, pager, next, jumper"
                    :page-size="GLOBAL.PAGESIZE"
                    :current-page.sync="zls_page"
                    :total="zls_total"
                    @current-change="getZlsTable">
                </el-pagination>
            </div>
            <div class="zls-edit" v-show="showZlsEdit">
                <h2>{{zls_edit_tit}}</h2>
                <el-form :model="zls_edit_form" label-width="120px">
                    <el-form-item label="主题类型名称">
                        <el-input placeholder="请输入主题类型名称" v-model="zls_edit_form.name"></el-input>
                    </el-form-item>
                    <el-form-item label="主题图片">
                        <img :src="zls_edit_form.thumbnail" id="zlsThumbnail">
                    </el-form-item>
                    <el-form-item label="主题简介">
                        <el-input
                            type="textarea"
                            :rows="3"
                            maxlength="30"
                            placeholder="请输入主题简介"
                            v-model="zls_edit_form.des"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="闯关地图">
                        <img :src="zls_edit_form.background_map" id="zlsMap">
                    </el-form-item>
                    <el-form-item label="闯关剧情">
                        <el-input placeholder="视频地址" v-model="zls_edit_form.introduction_video" readonly></el-input>
                        <el-button type="primary" id="zlsVideo">上传视频</el-button>
                        <el-button
                            type="primary"
                            v-show="zls_edit_form.introduction_video != ''"
                            @click="zls_edit_form.introduction_video = ''"
                        >删除视频</el-button>
                    </el-form-item>
                    <el-form-item label="闯关剧情封面">
                        <img :src="zls_edit_form.introduction_img" id="zlsIntroImg">
                        <el-button
                            type="primary"
                            v-show="zls_edit_form.introduction_img_done == true"
                            @click="zlsIntroCoverDel"
                            style="vertical-align: bottom;"
                        >删除封面</el-button>
                    </el-form-item>
                    <el-form-item
                        v-for="(item, index) in zls_edit_form.person"
                        :key="index"
                        :label="'人物' + (index + 1)"
                    >
                        <el-input placeholder="请输入主题人物名称" v-model="item.name"></el-input>
                        <i class="el-icon-circle-plus" @click="zlsPersonAdd" v-show="index==0"></i>
                        <i class="el-icon-remove" @click="zlsPersonDel(index)" v-show="index!=0"></i>
                        <el-row>
                            <label class="el-form-item__label">人物头像</label>
                            <img :src="item.img" :id="item.img_id">
                        </el-row>
                    </el-form-item>
                    <el-form-item>
                        <el-button @click="showZlsEdit=false">返回</el-button>
                        <el-button type="primary" @click="zlsEdit">确定</el-button>
                    </el-form-item>
                </el-form>
            </div>



            <!-- 剧情设置 -->
            <div class="jqs-list" v-show="show2 && !showJqsEdit">
                <el-row>
                    <el-button class="jh-width130" @click="backFun">返回</el-button>
                </el-row>
                <h1>剧情设置</h1>
                <el-form :inline="true" :model="jqs_list_form">
                    <el-form-item label="主题">
                        <el-select v-model="jqs_list_form.theme_id" filterable clearable placeholder="请选择主题">
                            <el-option v-for="item in theme_list" :key="item.theme_id" :label="item.theme_name" :value="item.theme_id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item class="pull-right">
                        <el-button type="primary" @click="jqsAdd">新增剧情</el-button>
                        <el-button type="primary" @click="getJqsTable(1)">查询</el-button>
                    </el-form-item>
                </el-form>
                <el-table
                    v-loading="loading"
                    element-loading-text="努力加载中，请稍后..."
                    element-loading-background="rgba(0, 0, 0, 0.6)"
                    :data="jqs_table">
                    <el-table-column prop="theme_name" label="主题类型"></el-table-column>
                    <el-table-column prop="name" label="名称"></el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <span class="text-blue" @click="jqsModify(scope.row)">修改</span>
                            <span class="text-blue" @click="jqsDel(scope.row.id)">删除</span>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                    background
                    layout="total, prev, pager, next, jumper"
                    :page-size="GLOBAL.PAGESIZE"
                    :current-page.sync="jqs_page"
                    :total="jqs_total"
                    @current-change="getJqsTable">
                </el-pagination>
            </div>
            <div class="jqs-edit" v-show="showJqsEdit">
                <h2>{{jqs_edit_tit}}</h2>
                <el-form :model="jqs_edit_form" label-width="120px">
                    <el-form-item label="主题类型">
                        <el-select v-model="jqs_edit_form.theme_id" filterable placeholder="请选择主题类型" @change="jqsThemeChange($event)">
                            <el-option v-for="item in theme_list" :key="item.theme_id" :label="item.theme_name" :value="item.theme_id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="剧情名称">
                        <el-input placeholder="请输入剧情名称" v-model="jqs_edit_form.name"></el-input>
                    </el-form-item>
                    <el-form-item
                        v-for="(items, index) in jqs_edit_form.dialog"
                        :key="items.person_id"
                        :label="'对话' + (index + 1)"
                    >
                        <el-row>
                            <label class="el-form-item__label">人物</label>
                            <el-select v-model="items.person_id" clearable filterable placeholder="请选择人物" class="jqs-input-mini">
                                <el-option v-for="item in person_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                            </el-select>
                            <i class="el-icon-circle-plus" @click="jqsDialogAdd" v-show="index==0"></i>
                            <i class="el-icon-remove" @click="jqsDialogDel(index)" v-show="index!=0"></i>
                        </el-row>
                        <el-row>
                            <label class="el-form-item__label">内容</label>
                            <el-input
                                type="textarea"
                                :rows="3"
                                placeholder="请输入内容"
                                class="jqs-input-mini"
                                v-model="items.msg"
                            >
                            </el-input>
                        </el-row>
                        <el-row>
                            <label class="el-form-item__label">变量选择</label>
                            <el-button @click="items.msg = items.msg.concat('{username}')">用户微信昵称</el-button>
                        </el-row>
                    </el-form-item>
                    <el-form-item>
                        <el-button @click="showJqsEdit=false">返回</el-button>
                        <el-button type="primary" @click="jqsEdit">确定</el-button>
                    </el-form-item>
                </el-form>
            </div>



            <!-- 答题卡设置 -->
            <div class="dts-list" v-show="show3 && !showDtsEdit">
                <el-row>
                    <el-button class="jh-width130" @click="backFun">返回</el-button>
                </el-row>
                <h1>答题卡设置</h1>
                <el-form :inline="true" :model="dts_list_form">
                    <el-form-item label="主题">
                        <el-select v-model="dts_list_form.theme_id" filterable clearable placeholder="请选择主题">
                            <el-option v-for="item in theme_list" :key="item.theme_id" :label="item.theme_name" :value="item.theme_id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item class="pull-right">
                        <el-button type="primary" @click="dtsAdd">新增答题卡</el-button>
                        <el-button type="primary" @click="getDtsTable(1)">查询</el-button>
                    </el-form-item>
                </el-form>
                <el-table
                    v-loading="loading"
                    element-loading-text="努力加载中，请稍后..."
                    element-loading-background="rgba(0, 0, 0, 0.6)"
                    :data="dts_table">
                    <el-table-column prop="theme_name" label="主题"></el-table-column>
                    <el-table-column prop="name" label="名称"></el-table-column>
                    <el-table-column prop="question" label="题目内容"></el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <span class="text-blue" @click="dtsModify(scope.row)">修改</span>
                            <span class="text-blue" @click="dtsDel(scope.row.id)">删除</span>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                    background
                    layout="total, prev, pager, next, jumper"
                    :page-size="GLOBAL.PAGESIZE"
                    :current-page.sync="dts_page"
                    :total="dts_total"
                    @current-change="getDtsTable">
                </el-pagination>
            </div>
            <div class="dts-edit" v-show="showDtsEdit">
                <h2>{{dts_edit_tit}}</h2>
                <el-form :model="dts_edit_form" label-width="120px">
                    <el-form-item label="主题类型">
                        <el-select v-model="dts_edit_form.theme_id" filterable placeholder="请选择主题类型">
                            <el-option v-for="item in theme_list" :key="item.theme_id" :label="item.theme_name" :value="item.theme_id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="名称">
                        <el-input placeholder="请输入答题卡名称" v-model="dts_edit_form.name"></el-input>
                    </el-form-item>
                    <el-form-item label="题目">
                        <el-input placeholder="请输入答题卡题目内容" v-model="dts_edit_form.question"></el-input>
                    </el-form-item>
                    <el-form-item label="答案">
                        <el-select v-model="dts_edit_form.answer" filterable clearable placeholder="请选择正确答案">
                            <el-option label="A" value="A"></el-option>
                            <el-option label="B" value="B"></el-option>
                            <el-option label="C" value="C"></el-option>
                            <el-option label="D" value="D"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="选项">
                        <el-row>
                            <label class="el-form-item__label">A</label>
                            <el-input placeholder="请输入答题卡选项内容" v-model="dts_edit_form.options.A"></el-input>
                        </el-row>
                        <el-row>
                            <label class="el-form-item__label">B</label>
                            <el-input placeholder="请输入答题卡选项内容" v-model="dts_edit_form.options.B"></el-input>
                        </el-row>
                        <el-row>
                            <label class="el-form-item__label">C</label>
                            <el-input placeholder="请输入答题卡选项内容" v-model="dts_edit_form.options.C"></el-input>
                        </el-row>
                        <el-row>
                            <label class="el-form-item__label">D</label>
                            <el-input placeholder="请输入答题卡选项内容" v-model="dts_edit_form.options.D"></el-input>
                        </el-row>
                    </el-form-item>
                    <el-form-item>
                        <el-button @click="showDtsEdit=false">返回</el-button>
                        <el-button type="primary" @click="dtsEdit">确定</el-button>
                    </el-form-item>
                </el-form>
            </div>



            <!-- 关卡设置 -->
            <div class="gks-list" v-show="show4 && !showGksEdit">
                <el-row>
                    <el-button class="jh-width130" @click="backFun">返回</el-button>
                </el-row>
                <h1>关卡设置</h1>
                <el-form :inline="true" :model="gks_list_form">
                    <el-form-item label="门店">
                        <el-select v-model="gks_list_form.shop_id" filterable placeholder="请选择门店" @change="gksListShop">
                            <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="主题">
                        <el-select v-model="gks_list_form.theme_id" filterable clearable placeholder="请选择主题">
                            <el-option v-for="item in gks_list_theme" :key="item.theme_id" :label="item.theme_name" :value="item.theme_id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="关卡名称">
                        <el-input placeholder="请输入关卡名称" v-model="gks_list_form.name"></el-input>
                    </el-form-item>
                    <el-form-item class="pull-right">
                        <el-button type="primary" @click="gksAdd">新增关卡</el-button>
                        <el-button type="primary" @click="getGksTable(1)">查询</el-button>
                    </el-form-item>
                </el-form>
                <el-table
                    v-loading="loading"
                    element-loading-text="努力加载中，请稍后..."
                    element-loading-background="rgba(0, 0, 0, 0.6)"
                    :data="gks_table">
                    <el-table-column prop="shop_name" label="门店"></el-table-column>
                    <el-table-column prop="no" label="关卡序号"></el-table-column>
                    <el-table-column prop="name" label="关卡名称"></el-table-column>
                    <el-table-column prop="theme_name" label="主题"></el-table-column>
                    <el-table-column prop="theme_story_line_name" label="关卡剧情名称"></el-table-column>
                    <el-table-column prop="type_name" label="闯关类型"></el-table-column>
                    <el-table-column prop="clock_in_name" label="闯关是否开启打卡签到"></el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <span class="text-blue" @click="gksModify(scope.row)">修改</span>
                            <span class="text-blue" @click="gksDel(scope.row.id)">删除</span>
                            <span class="text-blue" @click="gksQrcode(scope.row)">关卡二维码</span>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                    background
                    layout="total, prev, pager, next, jumper"
                    :page-size="GLOBAL.PAGESIZE"
                    :current-page.sync="gks_page"
                    :total="gks_total"
                    @current-change="getGksTable">
                </el-pagination>
                <!-- 关卡二维码 -->
                <div class="gks-qrcode-alert" ref="gks_qrcode_alert">
                    <div id="gksRowQrcode" class="gks-row-qrcode"></div>
                    <!-- <img :src="gks_row_qrcode" id="gksRowQrcode"> -->
                    <p>{{gks_row_name}}</p>
                    <el-row>
                        <el-button type="primary" @click="gksRowDl">下载到本地</el-button>
                    </el-row>
                </div>
            </div>
            <div class="gks-edit" v-show="showGksEdit">
                <h2>{{gks_edit_tit}}</h2>
                <el-form :model="gks_edit_form" label-width="160px">
                    <el-form-item label="门店">
                        <el-select v-model="gks_edit_form.shop_id" filterable placeholder="请选择门店" @change="gksEditShop">
                            <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="关卡序号">
                        <el-input placeholder="请输入关卡序号" v-model="gks_edit_form.no"></el-input>
                    </el-form-item>
                    <el-form-item label="关卡名称">
                        <el-input placeholder="请输入关卡名称" v-model="gks_edit_form.name"></el-input>
                    </el-form-item>
                    <el-form-item label="主题类型">
                        <el-select v-model="gks_edit_form.theme_id" filterable placeholder="请选择主题类型" @change="gksThemeChange">
                            <el-option v-for="item in gks_edit_theme" :key="item.theme_id" :label="item.theme_name" :value="item.theme_id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="关卡剧情">
                        <el-select v-model="gks_edit_form.theme_story_line_id" filterable placeholder="请选择关卡剧情">
                            <el-option v-for="item in story_list" :key="item.theme_story_line_id" :label="item.theme_story_line_name" :value="item.theme_story_line_id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="闯关类型">
                        <el-select v-model="gks_edit_form.type" clearable placeholder="请选择闯关类型">
                            <el-option label="拍照闯关" value="1"></el-option>
                            <el-option label="答题闯关" value="2"></el-option>
                            <el-option label="刷脸测颜值" value="3"></el-option>
                            <el-option label="交流馆" value="4"></el-option>
                            <el-option label="赛事评选" value="5"></el-option>
                        </el-select>
                        <el-row v-show="gks_edit_form.type == '1'">
                            <label class="el-form-item__label">上传拍照示例图</label>
                            <img :src="gks_edit_form.example_img" id="gksExampleImg">
                        </el-row>
                        <el-row v-show="gks_edit_form.type == '2'">
                            <label class="el-form-item__label">答题卡名称</label>
                            <el-select v-model="gks_edit_form.theme_question_id" filterable placeholder="请选择答题卡名称">
                                <el-option v-for="item in question_list" :key="item.theme_question_id" :label="item.theme_question_name" :value="item.theme_question_id"></el-option>
                            </el-select>
                        </el-row>
                    </el-form-item>
                    <el-form-item label="闯关是否需要打卡签到">
                        <el-select v-model="gks_edit_form.clock_in" placeholder="请选择">
                            <el-option label="是" value="1"></el-option>
                            <el-option label="否" value="-1"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="关卡地图坐标">
                        <el-row class="gks-edit-row">
                            <el-col :span="12">
                                <label class="el-form-item__label">X</label>
                                <el-input placeholder="请输入X坐标" v-model="gks_edit_form.coordinate.x" class="gks-input-mini"></el-input>
                            </el-col>
                            <el-col :span="12">
                                <label class="el-form-item__label">Y</label>
                                <el-input placeholder="请输入Y坐标" v-model="gks_edit_form.coordinate.y" class="gks-input-mini"></el-input>
                            </el-col>
                        </el-row>
                    </el-form-item>
                    <el-form-item label="关卡创作背景">
                        <el-input
                            type="textarea"
                            :rows="3"
                            placeholder="请输入关卡创作背景"
                            v-model="gks_edit_form.content"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="关卡图片">
                        <el-row class="gks-edit-row">
                            <el-col :span="8">
                                <dl>
                                    <dt><img :src="gks_edit_form.img_unfinished" id="gksPreImg"></dt>
                                    <dd>未闯关</dd>
                                </dl>
                            </el-col>
                            <el-col :span="8">
                                <dl>
                                    <dt><img :src="gks_edit_form.img_current" id="gksNowImg"></dt>
                                    <dd>闯关中</dd>
                                </dl>
                            </el-col>
                            <el-col :span="8">
                                <dl>
                                    <dt><img :src="gks_edit_form.img_finished" id="gksDoneImg"></dt>
                                    <dd>闯关完成</dd>
                                </dl>
                            </el-col>
                        </el-row>
                    </el-form-item>
                    <el-form-item>
                        <el-button @click="showGksEdit=false">返回</el-button>
                        <el-button type="primary" @click="gksEdit">确定</el-button>
                    </el-form-item>
                </el-form>
            </div>



            <!-- 闯关奖励规则设置 -->
            <div class="cjg-list" v-show="show5 && !showCjgEdit">
                <el-row>
                    <el-button class="jh-width130" @click="backFun">返回</el-button>
                </el-row>
                <h1>闯关奖励规则设置</h1>
                <p>注：闯关奖励规则中，一个门店只能设置一条通关奖励规则</p>
                <el-form :inline="true" :model="cjg_list_form">
                    <el-form-item label="门店">
                        <el-select v-model="cjg_list_form.shop_id" filterable placeholder="请选择门店" @change="cjgListShop">
                            <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="规则名称">
                        <el-input placeholder="请输入规则名称" v-model="cjg_list_form.name"></el-input>
                    </el-form-item>
                    <el-form-item label="规则类型">
                        <el-select v-model="cjg_list_form.type" clearable placeholder="请选择规则类型">
                            <el-option label="闯关奖励" value="1"></el-option>
                            <el-option label="通关奖励" value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="主题">
                        <el-select v-model="cjg_list_form.theme_id" filterable clearable placeholder="请选择主题">
                            <el-option v-for="item in cjg_list_theme" :key="item.theme_id" :label="item.theme_name" :value="item.theme_id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item class="pull-right">
                        <el-button type="primary" @click="cjgAdd">新增闯关奖励规则</el-button>
                        <el-button type="primary" @click="getCjgTable(1)">查询</el-button>
                    </el-form-item>
                </el-form>
                <el-table
                    v-loading="loading"
                    element-loading-text="努力加载中，请稍后..."
                    element-loading-background="rgba(0, 0, 0, 0.6)"
                    :data="cjg_table">
                    <el-table-column prop="shop_name" label="门店"></el-table-column>
                    <el-table-column prop="name" label="规则名称"></el-table-column>
                    <el-table-column prop="theme_name" label="主题"></el-table-column>
                    <el-table-column prop="levels_count" label="闯关成功总数"></el-table-column>
                    <el-table-column prop="type_name" label="规则类型"></el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <span class="text-blue" @click="cjgModify(scope.row.id)">修改</span>
                            <span class="text-blue" @click="cjgDel(scope.row)">删除</span>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                    background
                    layout="total, prev, pager, next, jumper"
                    :page-size="GLOBAL.PAGESIZE"
                    :current-page.sync="cjg_page"
                    :total="cjg_total"
                    @current-change="getCjgTable">
                </el-pagination>
            </div>
            <div class="cjg-edit" v-show="showCjgEdit">
                <h2>{{cjg_edit_tit}}</h2>
                <el-form :model="cjg_edit_form" label-width="130px">
                    <el-form-item label="门店">
                        <el-select v-model="cjg_edit_form.shop_id" filterable placeholder="请选择门店" @change="cjgEditShop">
                            <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="规则名称">
                        <el-input placeholder="请输入规则名称" v-model="cjg_edit_form.name"></el-input>
                    </el-form-item>
                    <el-form-item label="适用主题">
                        <el-select v-model="cjg_edit_form.theme_id" filterable placeholder="请选择适用主题">
                            <el-option v-for="item in cjg_edit_theme" :key="item.theme_id" :label="item.theme_name" :value="item.theme_id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="累计闯关成功次数">
                        <el-input placeholder="请输入累计闯关成功次数" v-model="cjg_edit_form.levels_count"></el-input>
                    </el-form-item>
                    <el-form-item label="规则类型">
                        <el-select v-model="cjg_edit_form.type" placeholder="请选择规则类型">
                            <el-option label="闯关奖励" value="1"></el-option>
                            <el-option label="通关奖励" value="2"></el-option>
                        </el-select>
                        <el-popover
                            placement="right"
                            width="500"
                            trigger="hover">
                            <div>
                                <p>闯关奖励：根据设置的累计闯关成功次数获取对应奖品</p>
                                <p>通关奖励：除根据设置的闯关成功总数几率获取奖对应品外，系统自动生成电子相册，通关奖励只能设置一条</p>
                            </div>
                            <i class="el-icon-question my-el-hint" slot="reference"></i>
                        </el-popover>
                    </el-form-item>
                    <el-form-item
                        v-for="(item, index) in cjg_edit_form.goods"
                        :key="index"
                        :label="'奖品' + (index + 1)"
                    >
                        <el-row class="cjg-edit-row">
                            <el-col :span="12">
                                <label class="el-form-item__label">奖品名称</label>
                                <el-input placeholder="请输入奖品名称" class="cjg-input-normal" v-model="item.name"></el-input>
                            </el-col>
                            <el-col :span="12">
                                <label class="el-form-item__label">得奖概率</label>
                                <el-input class="cjg-input-mini" v-model="item.probability"></el-input>
                                <span>%</span>
                            </el-col>
                        </el-row>
                        <el-row>
                            <label class="el-form-item__label">奖品图片</label>
                            <img :src="item.img" :id="item.img_id">
                            <el-button type="primary" @click="cjgPrizesAdd(index)">添加奖品券</el-button>
                        </el-row>
                        <el-table
                            :data="item.infos">
                            <el-table-column prop="gift_name" label="活动券名称"></el-table-column>
                            <el-table-column prop="gift_type_name" label="活动券类型"></el-table-column>
                            <el-table-column label="活动券数量">
                                <template slot-scope="scope">
                                    <el-input placeholder="请输入正整数" v-model="item.infos[scope.$index].quantity" class="cjg-table-input" @blur="cjgCouponQuantity($event, index, scope.$index, scope.row.quantity)"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="操作">
                                <template slot-scope="scope">
                                    <span class="text-blue" @click="cjgPrizesDel(index, scope.$index)">删除</span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-form-item>
                    <el-form-item>
                        <el-button @click="showCjgEdit=false">返回</el-button>
                        <el-button type="primary" @click="cjgEdit">确定</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <!-- 添加奖品 -->
			<div class="select-goods-wrap" ref="cjg_coupon_alert">
				<el-row :gutter="20">
					<el-col :span="8">
						<el-select v-model="coupon_type" clearable filterable placeholder="请选择类型" @change="couponTypeChange">
							<el-option label="优惠券" value="1"></el-option>
                            <el-option label="商品券" value="2"></el-option>
							<el-option label="商品套餐券" value="3"></el-option>
                            <el-option label="开房套餐券" value="4"></el-option>
						</el-select>
					</el-col>
					<el-col :span="10">
						<el-input placeholder="请输入活动券名称" v-model="coupon_name"></el-input>
					</el-col>
					<el-col :span="6">
						<el-button class="pull-right" type="primary" @click="getCouponTable(1)">查询</el-button>
					</el-col>
				</el-row>
				<el-table
					v-loading="loading"
					element-loading-text="努力加载中，请稍后..."
					element-loading-background="rgba(0, 0, 0, 0.6)"
					ref="coupon_table"
					:data="coupon_table"
					@selection-change="getCouponSelect">
					<el-table-column type="selection"></el-table-column>
					<el-table-column prop="type_name" label="类型"></el-table-column>
					<el-table-column prop="name" label="名称"></el-table-column>
				</el-table>
				<el-pagination
					background
					layout="total, prev, pager, next, jumper"
					:page-size="GLOBAL.PAGESIZEMINI"
					:current-page.sync="coupon_page"
					:total="coupon_total"
					@current-change="getCouponTable">
				</el-pagination>
			</div>



            <!-- 闯关游戏设置 -->
            <div class="cys-list" v-show="show6 && !showCysEdit">
                <el-row>
                    <el-button class="jh-width130" @click="backFun">返回</el-button>
                </el-row>
                <h1>闯关游戏设置</h1>
                <el-form :inline="true" :model="cys_list_form">
                    <el-form-item label="门店">
                        <el-select v-model="cys_list_form.shop_id" filterable placeholder="请选择门店">
                            <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item class="pull-right">
                        <el-button type="primary" @click="cysAdd">新增闯关游戏</el-button>
                        <el-button type="primary" @click="getCysTable(1)">查询</el-button>
                    </el-form-item>
                </el-form>
                <el-table
                    v-loading="loading"
                    element-loading-text="努力加载中，请稍后..."
                    element-loading-background="rgba(0, 0, 0, 0.6)"
                    :data="cys_table">
                    <el-table-column prop="listorder" label="序号"></el-table-column>
                    <el-table-column prop="shop_name" label="门店"></el-table-column>
                    <el-table-column prop="theme_name" label="主题类型"></el-table-column>
                    <el-table-column label="定位">
                        <template slot-scope="scope">
                            {{scope.row.get_location == '1' ? '开启' : '关闭'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="status_name" label="状态"></el-table-column>
                    <el-table-column label="操作" width="200">
                        <template slot-scope="scope">
                            <span class="text-blue" @click="cysModify(scope.row)">修改</span>
                            <span class="text-blue" @click="cysDel(scope.row.id)">删除</span>
                            <span class="text-blue" @click="cysStatus(scope.row.id)">{{scope.row.status == '1' ? '禁用' : '启用'}}</span>
                            <span class="text-blue" @click="cysCopy(scope.row.qrcode)">复制链接</span>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                    background
                    layout="total, prev, pager, next, jumper"
                    :page-size="GLOBAL.PAGESIZE"
                    :current-page.sync="cys_page"
                    :total="cys_total"
                    @current-change="getCysTable">
                </el-pagination>
            </div>
            <div class="cys-edit" v-show="showCysEdit">
                <h2>{{cys_edit_tit}}</h2>
                <el-form :model="cys_edit_form" label-width="130px">
                    <el-form-item label="门店">
                        <el-select v-model="cys_edit_form.shop_id" filterable placeholder="请选择门店">
                            <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="主题类型">
                        <el-select v-model="cys_edit_form.theme_id" filterable placeholder="请选择主题类型">
                            <el-option v-for="item in theme_list" :key="item.theme_id" :label="item.theme_name" :value="item.theme_id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="显示序号">
                        <el-input placeholder="请输入显示序号" v-model="cys_edit_form.listorder"></el-input>
                    </el-form-item>
                    <el-form-item label="定位限制">
                        <el-select v-model="cys_edit_form.get_location" placeholder="请选择定位限制">
                            <el-option label="开启" value="1"></el-option>
                            <el-option label="关闭" value="-1"></el-option>
                        </el-select>
                        <el-popover
                            placement="right"
                            width="500"
                            trigger="hover">
                            <div>
                                <p>开启：用户需要在门店内才能开始闯关游戏</p>
                                <p>关闭：用户可在任意地方开始闯关游戏</p>
                            </div>
                            <i class="el-icon-question my-el-hint" slot="reference"></i>
                        </el-popover>
                    </el-form-item>
                    <el-form-item>
                        <el-button @click="showCysEdit=false">返回</el-button>
                        <el-button type="primary" @click="cysEdit">确定</el-button>
                    </el-form-item>
                </el-form>
            </div>

        </div>
    </div>
</template>
<script>
    import Vue from 'vue'
    import QRCode from 'qrcodejs2'
    export default {
        name: '',
        data() {
            return {
                showTit: true,
                show1: false,
                show2: false,
                show3: false,
                show4: false,
                show5: false,
                show6: false,
                loading: false,
                shop_list: [],
                theme_list: [],
                person_list: [],
                story_list: [],
                question_list: [],

                // 主题类型设置
                showZlsEdit: false,
                zls_page: 1,
				zls_total: 0,
                zls_table: [],
                zls_edit_id: '',
                zls_edit_tit: '',
                zls_edit_form: {
                    name: '',
                    thumbnail: require('../../assets/images/upload_btn.png'),
                    thumbnail_done: false,
                    des: '',
                    background_map: require('../../assets/images/upload_btn.png'),
                    background_map_done: false,
                    introduction_video: '',
                    introduction_img: require('../../assets/images/upload_btn.png'),
                    introduction_img_done: false,
                    person: [{
                        id: '',
                        name: '',
                        img: require('../../assets/images/upload_btn.png'),
                        img_id: 'zlsImg0',
                        img_done: false
                    }]
                },

                // 剧情设置
                showJqsEdit: false,
                jqs_list_form: {
                    theme_id: ''
                },
                jqs_page: 1,
				jqs_total: 0,
                jqs_table: [],
                jqs_edit_id: '',
                jqs_edit_tit: '',
                jqs_edit_form: {
                    theme_id: '',
                    name: '',
                    dialog: [{
                        person_id: '',
                        msg: ''
                    }]
                },

                // 答题卡设置
                showDtsEdit: false,
                dts_list_form: {
                    theme_id: ''
                },
                dts_page: 1,
				dts_total: 0,
                dts_table: [],
                dts_edit_id: '',
                dts_edit_tit: '',
                dts_edit_form: {
                    theme_id: '',
                    name: '',
                    question: '',
                    answer: '',
                    options: {
                        A: '',
                        B: '',
                        C: '',
                        D: ''
                    }
                },

                // 关卡设置
                showGksEdit: false,
                gks_list_theme: [],
                gks_list_form: {
                    shop_id: '',
                    theme_id: '',
                    name: ''
                },
                gks_page: 1,
				gks_total: 0,
                gks_table: [],
                gks_row_qrcode: '',
                gks_row_name: '',
                gks_edit_id: '',
                gks_edit_tit: '',
                gks_edit_theme: [],
                gks_edit_form: {
                    shop_id: '',
                    no: '',
                    name: '',
                    theme_id: '',
                    theme_story_line_id: '',
                    type: '',
                    example_img: require('../../assets/images/upload_btn.png'),
                    example_img_done: false,
                    theme_question_id: '',
                    clock_in: '',
                    coordinate: {
                        x: '',
                        y: ''
                    },
                    content: '',
                    img_unfinished: require('../../assets/images/upload_btn.png'),
                    img_unfinished_done: false,
                    img_current: require('../../assets/images/upload_btn.png'),
                    img_current_done: false,
                    img_finished: require('../../assets/images/upload_btn.png'),
                    img_finished_done: false
                },

                // 闯关奖励规则设置
                showCjgEdit: false,
                cjg_list_theme: [],
                cjg_list_form: {
                    shop_id: '',
                    name: '',
                    type: '',
                    theme_id: ''
                },
                cjg_page: 1,
				cjg_total: 0,
                cjg_table: [],
                cjg_edit_id: '',
                cjg_edit_tit: '',
                cjg_edit_theme: [],
                cjg_edit_form: {
                    shop_id: '',
                    name: '',
                    theme_id: '',
                    levels_count: '',
                    type: '',
                    goods: [{
                        name: '',
                        probability: '',
                        img: require('../../assets/images/upload_btn.png'),
                        img_id: 'cjgImg0',
                        img_done: false,
                        infos: []
                    }, {
                        name: '',
                        probability: '',
                        img: require('../../assets/images/upload_btn.png'),
                        img_id: 'cjgImg1',
                        img_done: false,
                        infos: []
                    }, {
                        name: '',
                        probability: '',
                        img: require('../../assets/images/upload_btn.png'),
                        img_id: 'cjgImg2',
                        img_done: false,
                        infos: []
                    }]
                },

				coupon_type: '',
				coupon_name: '',
				coupon_page: 1,
				coupon_total: 0,
                coupon_table: [],
                coupon_table_select: [],

                // 闯关游戏设置
                showCysEdit: false,
                cys_list_theme: [],
                cys_list_form: {
                    shop_id: '',
                    name: '',
                    type: '',
                    theme_id: ''
                },
                cys_page: 1,
				cys_total: 0,
                cys_table: [],
                cys_edit_id: '',
                cys_edit_tit: '',
                cys_edit_form: {
                    shop_id: '',
                    theme_id: '',
                    listorder: '',
                    get_location: ''
                },
            }
        },
        computed: {
            menu() {
                let menu = {};
                if(!$.isEmptyObject(this.$store.state.menunew)) {
                    menu = JSON.parse(this.$store.state.menunew);
                    menu.forEach(_ => {
                        if(_.id == '1215') { // 门票
                            menu = _.submenu;
                            menu.forEach(v => {
                                if(v.id == '1219') { // 关卡管理
                                    menu = v.submenu;
                                }
                            })
                        }
                    })
                }
                return menu;
            },
        },
        created: function() {
            this.getShop()
            this.getTheme()
        },
        mounted: function() {
            this.zlsUpload('zlsThumbnail')
            this.zlsUpload('zlsMap')
            this.zlsUpload('zlsVideo')
            this.zlsUpload('zlsIntroImg')
            this.zlsImgUploadInit()
            this.gksImgUpload('gksExampleImg')
            this.gksImgUpload('gksPreImg')
            this.gksImgUpload('gksNowImg')
            this.gksImgUpload('gksDoneImg')
            this.cjgImgUpload('cjgImg0', 0)
            this.cjgImgUpload('cjgImg1', 1)
            this.cjgImgUpload('cjgImg2', 2)
        },
        methods: {
            titClk: function(menu_id) {
                const _this = this

                _this.showTit = false
                _this.show1 = false
                _this.show2 = false
                _this.show3 = false
                _this.show4 = false
                _this.show5 = false
                _this.show6 = false
                if(menu_id == '1231') { // 主题类型设置
                    _this.getZlsTable(1)
                    _this.show1 = true
                } else if(menu_id == '1232') { // 剧情设置
                    _this.jqs_list_form.theme_id = ''
                    _this.getJqsTable(1)
                    _this.show2 = true
                } else if(menu_id == '1233') { // 答题卡设置
                    _this.dts_list_form.theme_id = ''
                    _this.getDtsTable(1)
                    _this.show3 = true
                } else if(menu_id == '1234') { // 关卡设置
                    _this.gks_list_form.shop_id = _this.shop_list[0].id
                    _this.gks_list_form.theme_id = ''
                    new Promise(resolve => {
                        _this.getShopTheme(this.shop_list[0].id, 'gks_list', resolve);
                    })
                    _this.gks_list_form.name = ''
                    _this.getGksTable(1)
                    _this.show4 = true
                } else if(menu_id == '1235') { // 闯关奖励设置
                    _this.cjg_list_form.shop_id = _this.shop_list[0].id
                    _this.cjg_list_form.name = ''
                    _this.cjg_list_form.type = ''
                    _this.cjg_list_form.theme_id = ''
                    new Promise(resolve => {
                        _this.getShopTheme(this.shop_list[0].id, 'cjg_list', resolve);
                    })
                    _this.getCjgTable(1)
                    _this.show5 = true
                } else if(menu_id == '1236') { // 闯关游戏设置
                    _this.cys_list_form.shop_id = _this.shop_list[0].id
                    _this.getCysTable(1)
                    _this.show6 = true
                }
            },
            backFun: function() {
                this.showTit = true
                this.show1 = false
                this.show2 = false
                this.show3 = false
                this.show4 = false
                this.show5 = false
                this.show6 = false
            },
            // 获取门店
            getShop: function() {
                const _this = this;

                Vue.axios.post('PublicData/api_getShopListByPurview', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.shop_list = res.data.response.result;
                        _this.shop_list.shift();
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },
            // 门店下的主题
            getShopTheme(shop_id, name, resolve) {
                const _this = this;

                Vue.axios.post('BistroLevels/getBistroThemeSearchList', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        if(name == 'gks_list') {
                            _this.gks_list_theme = res.data.response.result
                        } else if(name == 'gks_edit') {
                            _this.gks_edit_theme = res.data.response.result
                        } else if(name == 'cjg_list') {
                            _this.cjg_list_theme = res.data.response.result
                        } else if(name == 'cjg_edit') {
                            _this.cjg_edit_theme = res.data.response.result
                        }
                        resolve()
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },
            // 全部主题
            getTheme() {
                const _this = this;

                Vue.axios.post('BistroLevels/getBistroThemeSearchList', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.theme_list = res.data.response.result;
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },
            // 获取主题人物
            getThemePerson(theme_id, resolve) {
                const _this = this;

                Vue.axios.post('BistroLevels/getBistroThemePersonList', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "theme_id": theme_id
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.person_list = res.data.response.result;
                        resolve();
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },
            // 获取主题剧情
            getThemeStory(theme_id, resolve) {
                const _this = this;

                Vue.axios.post('BistroLevels/getStoryLineSearchList', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "theme_id": theme_id
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.story_list = res.data.response.result;
                        resolve();
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },
            // 获取主题题目
            getThemeQuestion(theme_id, resolve) {
                const _this = this;

                Vue.axios.post('BistroLevels/getQuestionsSearchList', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "theme_id": theme_id
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.question_list = res.data.response.result;
                        resolve();
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },



            /*
             * 主题类型设置
             */
            // 列表
			getZlsTable: function(page) {
				const _this = this;

				_this.loading = true;
				Vue.axios.post('BistroLevels/getBistroThemeList', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
							"page_size": _this.GLOBAL.PAGESIZE
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.zls_total = Number(res.data.response.result.count);
                            _this.zls_page = 1
						}
						_this.zls_table = res.data.response.result.data;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
            },
            // 删除
			zlsDel(id) {
				const _this = this;

				layer.confirm('删除后不可恢复，确定删除吗？', {
					btn: ['确定', '取消']
				}, function() {
					Vue.axios.post('BistroLevels/delBistroTheme', {
						"header": Vue.request_header,
						"request": {
							"version": Vue.version,
							"param": {
								"id": id
							}
						},
						"comment": ""
					})
					.then(res => {
						if(res.data.response.result_code == "true") {
							layer.msg('删除成功');
							_this.getZlsTable(_this.zls_page);
                            _this.getTheme()
						} else {
							Vue.timeoutfun(res.data.response.result_status, _this);
							layer.msg(res.data.response.error_msg);
						}
					})
					.catch(err => {
						layer.msg('出错啦');
					});
				});
            },
            // 点击新增
			zlsAdd() {
                this.zls_edit_id = ''
                this.zls_edit_tit = '新增主题'
                this.zls_edit_form = {
                    name: '',
                    thumbnail: require('../../assets/images/upload_btn.png'),
                    thumbnail_done: false,
                    des: '',
                    background_map: require('../../assets/images/upload_btn.png'),
                    background_map_done: false,
                    introduction_video: '',
                    introduction_img: require('../../assets/images/upload_btn.png'),
                    introduction_img_done: false,
                    person: [{
                        id: '',
                        name: '',
                        img: require('../../assets/images/upload_btn.png'),
                        img_id: 'zlsImg0',
                        img_done: false
                    }]
                }
                this.zlsImgUpload('zlsImg0', 0)
                this.showZlsEdit = true
			},
			// 点击修改
			zlsModify(row) {
                this.zls_edit_id = row.id
				this.zls_edit_tit = '修改主题'
                this.zls_edit_form = {
                    name: row.name,
                    thumbnail: row.thumbnail,
                    thumbnail_done: true,
                    des: row.des,
                    background_map: row.background_map,
                    background_map_done: true,
                    introduction_video: row.introduction_video,
                    introduction_img: require('../../assets/images/upload_btn.png'),
                    introduction_img_done: false,
                    person: []
                }
                if(row.introduction_img) {
                    this.zls_edit_form.introduction_img = row.introduction_img
                    this.zls_edit_form.introduction_img_done = true
                }
                if(row.person.length == 0) {
                    this.zls_edit_form.person = [{
                        id: '',
                        name: '',
                        img: require('../../assets/images/upload_btn.png'),
                        img_id: 'zlsImg0',
                        img_done: false
                    }]
                } else {
                    row.person.forEach((item, index) => {
                        this.zls_edit_form.person.push({
                            id: item.id,
                            name: item.name,
                            img: item.img,
                            img_id: 'zlsImg' + index,
                            img_done: true
                        })
                        this.zlsImgUpload('zlsImg' + index, index)
                    })
                }
                this.showZlsEdit = true
            },
            // 删除闯关剧情封面
            zlsIntroCoverDel() {
                this.zls_edit_form.introduction_img = require('../../assets/images/upload_btn.png')
                this.zls_edit_form.introduction_img_done = false
            },
            // 新增人物
            zlsPersonAdd: function() {
                const index = this.zls_edit_form.person.length
                this.zls_edit_form.person.push({
                    id: '',
                    name: '',
                    img: require('../../assets/images/upload_btn.png'),
                    img_id: 'zlsImg' + index,
                    img_done: false
                })
				this.zlsImgUpload('zlsImg' + index, index)
            },
            // 删除人物
            zlsPersonDel: function(num) {
                this.zls_edit_form.person.splice(num, 1)
                this.zls_edit_form.person.forEach((item, index) => {
                    this.zls_edit_form.person[index].img_id = 'zlsImg' + index
                })
            },
            // 图片、视频
			zlsUpload: function(id) {
				let _this = this;
				let host = '',
					dir = '',
					file_name = '';

				setTimeout(function() {
					// 实例化一个plupload上传对象
					let uploader = new plupload.Uploader({
						browse_button: id, // 选择文件id
						filters: {
							mime_types: [ // 文件格式限制
								{ title: "Image files", extensions: "jpg,jpeg,png,gif,mp4,mkv" }
							],
							// max_file_size: '2mb', // 文件大小限制
							// prevent_duplicates: true // 不允许选取重复文件
						},
						// resize: {
						// 	width: 527,
						// 	height: 296
						// },
						multi_selection: false, // 单选
						url: './', // OSS地址
						init: {
							// 文件上传前触发
							BeforeUpload: function(up, file) {},
							// 文件选择完毕触发
							FilesAdded: function(up, files) {
								// 获取签名
								Vue.axios.post('publicData/api_getOssSignature', {
									"header": Vue.request_header,
									"request": {
										"version": Vue.version,
										"param": {
											"file": files[0].name,
											"path": 'ticket_system'
										}
									},
									"comment": ""
								})
								.then(res => {
									if(res.data.response.result_code == "true") {
										host = res.data.response.data.host;
										dir = res.data.response.data.dir;
										file_name = res.data.response.data.file_name;
										const new_params = {
											'key': dir + file_name,
											'OSSAccessKeyId': res.data.response.data.accessid,
											'policy': res.data.response.data.policy,
											'signature': res.data.response.data.signature,
											'success_action_status': '200', // 让服务端返回200，不然，默认会返回204
										};
										up.setOption({
											'url': host,
											'multipart_params': new_params
										});

										// 上传文件
										uploader.start();
									} else {
										Vue.timeoutfun(data.response.result_status, _this);
										layer.msg(data.response.error_msg);
									}
								})
								.catch(err => {
									layer.msg("出错啦");
								});
							},
							// 文件上传成功触发
							FileUploaded: function(up, file, data) {
                                switch(id) {
                                    case 'zlsThumbnail':
                                        _this.zls_edit_form.thumbnail = host + "/" + dir + file_name
                                        _this.zls_edit_form.thumbnail_done = true
                                        break
                                    case 'zlsMap':
                                        _this.zls_edit_form.background_map = host + "/" + dir + file_name
								        _this.zls_edit_form.background_map_done = true
                                        break
                                    case 'zlsVideo':
                                        _this.zls_edit_form.introduction_video = host + "/" + dir + file_name
                                        break
                                    case 'zlsIntroImg':
                                        _this.zls_edit_form.introduction_img = host + "/" + dir + file_name
								        _this.zls_edit_form.introduction_img_done = true
                                        break
                                }
                                // if(id == 'zlsThumbnail') {
                                //     _this.zls_edit_form.thumbnail = host + "/" + dir + file_name;
								//     _this.zls_edit_form.thumbnail_done = true;
                                // } else if(id == 'zlsMap') {
                                //     _this.zls_edit_form.background_map = host + "/" + dir + file_name;
								//     _this.zls_edit_form.background_map_done = true;
                                // } else if(id == 'zlsVideo') {
                                //     _this.zls_edit_form.introduction_video = host + "/" + dir + file_name;
                                // } else if(id == 'zlsIntroImg') {
                                //     _this.zls_edit_form.introduction_img = host + "/" + dir + file_name;
								//     _this.zls_edit_form.introduction_img_done = true;
                                // }
								layer.msg('上传成功');
							},
							// 错误提示
							Error: function(up, err) {
								if(err.code == -600) {
									layer.msg('请选择2mb以内的文件');
								} else if (err.code == -601) {
									layer.msg('只允许上传jpg,jpeg,png,gif文件');
								} else if (err.code == -602) {
									layer.msg('这个文件已经上传过一遍了');
								} else {
									layer.msg(err.response);
								}
							}
						}
					});
					// 初始化
					uploader.init();
				}, 20);
            },
            // 上传人物图片
            zlsImgUploadInit: function() {
				let _this = this;
				let host = '',
					dir = '',
					file_name = '';

				setTimeout(function() {
					// 实例化一个plupload上传对象
					let uploader = new plupload.Uploader({
						browse_button: 'zlsImg0', // 选择文件id
						filters: {
							mime_types: [ // 文件格式限制
								{ title: "Image files", extensions: "jpg,jpeg,png,gif" }
							],
							// max_file_size: '2mb', // 文件大小限制
							// prevent_duplicates: true // 不允许选取重复文件
						},
						// resize: {
						// 	width: 527,
						// 	height: 296
						// },
						multi_selection: false, // 单选
						url: './', // OSS地址
						init: {
							// 文件上传前触发
							BeforeUpload: function(up, file) {},
							// 文件选择完毕触发
							FilesAdded: function(up, files) {
								// 获取签名
								Vue.axios.post('publicData/api_getOssSignature', {
									"header": Vue.request_header,
									"request": {
										"version": Vue.version,
										"param": {
											"file": files[0].name,
											"path": 'ticket_system'
										}
									},
									"comment": ""
								})
								.then(res => {
									if(res.data.response.result_code == "true") {
										host = res.data.response.data.host;
										dir = res.data.response.data.dir;
										file_name = res.data.response.data.file_name;
										const new_params = {
											'key': dir + file_name,
											'OSSAccessKeyId': res.data.response.data.accessid,
											'policy': res.data.response.data.policy,
											'signature': res.data.response.data.signature,
											'success_action_status': '200', // 让服务端返回200，不然，默认会返回204
										};
										up.setOption({
											'url': host,
											'multipart_params': new_params
										});

										// 上传文件
										uploader.start();
									} else {
										Vue.timeoutfun(data.response.result_status, _this);
										layer.msg(data.response.error_msg);
									}
								})
								.catch(err => {
									layer.msg("出错啦");
								});
							},
							// 文件上传成功触发
							FileUploaded: function(up, file, data) {
								_this.zls_edit_form.person[0].img = host + "/" + dir + file_name;
								_this.zls_edit_form.person[0].img_done = true;
								layer.msg('上传成功');
							},
							// 错误提示
							Error: function(up, err) {
								if(err.code == -600) {
									layer.msg('请选择2mb以内的文件');
								} else if (err.code == -601) {
									layer.msg('只允许上传jpg,jpeg,png,gif文件');
								} else if (err.code == -602) {
									layer.msg('这个文件已经上传过一遍了');
								} else {
									layer.msg(err.response);
								}
							}
						}
					});
					// 初始化
					uploader.init();
				}, 20);
            },
			zlsImgUpload: function(id, index) {
                if(index === 0) {
                    return false;
                }
				let _this = this;
				let host = '',
					dir = '',
					file_name = '';

				setTimeout(function() {
					// 实例化一个plupload上传对象
					let uploader = new plupload.Uploader({
						browse_button: id, // 选择文件id
						filters: {
							mime_types: [ // 文件格式限制
								{ title: "Image files", extensions: "jpg,jpeg,png,gif" }
							],
							// max_file_size: '2mb', // 文件大小限制
							// prevent_duplicates: true // 不允许选取重复文件
						},
						// resize: {
						// 	width: 527,
						// 	height: 296
						// },
						multi_selection: false, // 单选
						url: './', // OSS地址
						init: {
							// 文件上传前触发
							BeforeUpload: function(up, file) {},
							// 文件选择完毕触发
							FilesAdded: function(up, files) {
								// 获取签名
								Vue.axios.post('publicData/api_getOssSignature', {
									"header": Vue.request_header,
									"request": {
										"version": Vue.version,
										"param": {
											"file": files[0].name,
											"path": 'ticket_system'
										}
									},
									"comment": ""
								})
								.then(res => {
									if(res.data.response.result_code == "true") {
										host = res.data.response.data.host;
										dir = res.data.response.data.dir;
										file_name = res.data.response.data.file_name;
										const new_params = {
											'key': dir + file_name,
											'OSSAccessKeyId': res.data.response.data.accessid,
											'policy': res.data.response.data.policy,
											'signature': res.data.response.data.signature,
											'success_action_status': '200', // 让服务端返回200，不然，默认会返回204
										};
										up.setOption({
											'url': host,
											'multipart_params': new_params
										});

										// 上传文件
										uploader.start();
									} else {
										Vue.timeoutfun(data.response.result_status, _this);
										layer.msg(data.response.error_msg);
									}
								})
								.catch(err => {
									layer.msg("出错啦");
								});
							},
							// 文件上传成功触发
							FileUploaded: function(up, file, data) {
								_this.zls_edit_form.person[index].img = host + "/" + dir + file_name;
								_this.zls_edit_form.person[index].img_done = true;
								layer.msg('上传成功');
							},
							// 错误提示
							Error: function(up, err) {
								if(err.code == -600) {
									layer.msg('请选择2mb以内的文件');
								} else if (err.code == -601) {
									layer.msg('只允许上传jpg,jpeg,png,gif文件');
								} else if (err.code == -602) {
									layer.msg('这个文件已经上传过一遍了');
								} else {
									layer.msg(err.response);
								}
							}
						}
					});
					// 初始化
					uploader.init();
				}, 20);
            },
            // 新增、修改
			zlsEdit() {
                const _this = this;

                if(!_this.zls_edit_form.thumbnail_done) {
                    layer.msg('请上传主题图片')
                    return false
                } else if(!_this.zls_edit_form.background_map_done) {
                    layer.msg('请上传闯关地图')
                    return false
                }
                let introduction_img = ''
                if(_this.zls_edit_form.introduction_img_done) {
                    introduction_img = _this.zls_edit_form.introduction_img
                }
                let person = [];
				_this.zls_edit_form.person.forEach(v => {
					if(v.name != '' && v.img_done) {
						person.push(v);
					}
				});
                let data = {
                    "header": Vue.request_header,
					"request": {
						"param": {
							"name": _this.zls_edit_form.name,
                            "thumbnail": _this.zls_edit_form.thumbnail,
                            "des": _this.zls_edit_form.des,
                            "background_map": _this.zls_edit_form.background_map,
                            "introduction_video": _this.zls_edit_form.introduction_video,
                            "introduction_img": introduction_img,
                            "person": person
						}
					},
					"comment": ""
                };
                if(_this.zls_edit_id) {
                    data.request.param.id = _this.zls_edit_id;
                }
                Vue.axios({
					method: 'post',
					url: 'BistroLevels/addBistroTheme',
					data: data
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						layer.msg('操作成功')
                        _this.getZlsTable(_this.zls_page)
                        _this.getTheme()
						_this.showZlsEdit = false
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
            },



            /*
             * 剧情设置
             */
            // 列表
			getJqsTable: function(page) {
				const _this = this;

				_this.loading = true;
				Vue.axios.post('BistroLevels/getStoryLineList', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
                            "page_size": _this.GLOBAL.PAGESIZE,
                            "theme_id": _this.jqs_list_form.theme_id
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
                            _this.jqs_total = Number(res.data.response.result.count)
                            _this.jqs_page = 1
						}
						_this.jqs_table = res.data.response.result.data;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
            },
            // 删除
			jqsDel(id) {
				const _this = this;

				layer.confirm('删除后不可恢复，确定删除吗？', {
					btn: ['确定', '取消']
				}, function() {
					Vue.axios.post('BistroLevels/delStoryLine', {
						"header": Vue.request_header,
						"request": {
							"version": Vue.version,
							"param": {
								"id": id
							}
						},
						"comment": ""
					})
					.then(res => {
						if(res.data.response.result_code == "true") {
							layer.msg('删除成功');
							_this.getJqsTable(_this.jqs_page);
						} else {
							Vue.timeoutfun(res.data.response.result_status, _this);
							layer.msg(res.data.response.error_msg);
						}
					})
					.catch(err => {
						layer.msg('出错啦');
					});
				});
            },
            // 点击新增
			jqsAdd() {
                this.jqs_edit_id = ''
                this.jqs_edit_tit = '新增剧情'
                this.jqs_edit_form = {
                    theme_id: this.theme_list[0].theme_id,
                    name: '',
                    dialog: [{
                        person_id: '',
                        msg: ''
                    }]
                }
                new Promise(resolve => {
					this.getThemePerson(this.jqs_edit_form.theme_id, resolve);
                })
                this.showJqsEdit = true;
			},
			// 点击修改
			jqsModify(row) {
                this.jqs_edit_id = row.id
                this.jqs_edit_tit = '修改剧情'
                this.jqs_edit_form = {}
                this.jqs_edit_form = {
                    theme_id: row.theme_id,
                    name: row.name,
                    dialog: []
                }
                new Promise(resolve => {
					this.getThemePerson(this.jqs_edit_form.theme_id, resolve)
                })
                if(row.dialog.length == 0) {
                    this.jqs_edit_form.dialog = [{
                        person_id: '',
                        msg: ''
                    }]
                } else {
                    row.dialog.forEach(item => {
                        this.jqs_edit_form.dialog.push({
                            person_id: item.person_id,
                            msg: item.msg
                        });
                    });
                    // this.jqs_edit_form.dialog = row.dialog
                }
                this.showJqsEdit = true;
            },
            // 更改主题
            jqsThemeChange(val) {
                new Promise(resolve => {
					this.getThemePerson(val, resolve)
                })
                this.jqs_edit_form.dialog = [{
                    person_id: '',
                    msg: ''
                }]
            },
            // 新增对话
            jqsDialogAdd: function() {
                this.jqs_edit_form.dialog.push({
                    person_id: '',
                    msg: ''
                });
            },
            // 删除对话
            jqsDialogDel: function(num) {
                this.jqs_edit_form.dialog.splice(num, 1);
            },
            // 新增、修改
			jqsEdit() {
                const _this = this;

                let dialog = [];
				_this.jqs_edit_form.dialog.forEach(v => {
					if(v.person_id != '' && v.msg != '') {
						dialog.push(v);
					}
				});
                let data = {
                    "header": Vue.request_header,
					"request": {
						"param": {
                            "theme_id": _this.jqs_edit_form.theme_id,
							"name": _this.jqs_edit_form.name,
                            "dialog": dialog
						}
					},
					"comment": ""
                };
                if(_this.jqs_edit_id) {
                    data.request.param.id = _this.jqs_edit_id;
                }
                Vue.axios({
					method: 'post',
					url: 'BistroLevels/addStoryLine',
					data: data
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						layer.msg('操作成功');
						_this.getJqsTable(_this.jqs_page);
						_this.showJqsEdit = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
            },



            /*
             * 答题卡设置
             */
            // 列表
			getDtsTable: function(page) {
				const _this = this;

				_this.loading = true;
				Vue.axios.post('BistroLevels/getQuestionsList', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
                            "page_size": _this.GLOBAL.PAGESIZE,
                            "theme_id": _this.dts_list_form.theme_id
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
                            _this.dts_total = Number(res.data.response.result.count);
                            _this.dts_page = 1
						}
						_this.dts_table = res.data.response.result.data;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
            },
            // 删除
			dtsDel(id) {
				const _this = this;

				layer.confirm('删除后不可恢复，确定删除吗？', {
					btn: ['确定', '取消']
				}, function() {
					Vue.axios.post('BistroLevels/delQuestion', {
						"header": Vue.request_header,
						"request": {
							"version": Vue.version,
							"param": {
								"id": id
							}
						},
						"comment": ""
					})
					.then(res => {
						if(res.data.response.result_code == "true") {
							layer.msg('删除成功');
							_this.getDtsTable(_this.dts_page);
						} else {
							Vue.timeoutfun(res.data.response.result_status, _this);
							layer.msg(res.data.response.error_msg);
						}
					})
					.catch(err => {
						layer.msg('出错啦');
					});
				});
            },
            // 点击新增
			dtsAdd() {
                this.dts_edit_id = ''
                this.dts_edit_tit = '新增答题卡'
                this.dts_edit_form = {
                    theme_id: this.theme_list[0].theme_id,
                    name: '',
                    question: '',
                    answer: '',
                    options: {
                        A: '',
                        B: '',
                        C: '',
                        D: ''
                    }
                }
                this.showDtsEdit = true;
			},
			// 点击修改
			dtsModify(row) {
                this.dts_edit_id = row.id
				this.dts_edit_tit = '修改答题卡'
                this.dts_edit_form = {
                    theme_id: row.theme_id,
                    name: row.name,
                    question: row.question,
                    answer: row.answer,
                    options: {
                        A: row.options.A,
                        B: row.options.B,
                        C: row.options.C,
                        D: row.options.D
                    }
                }
                this.showDtsEdit = true;
            },
            // 新增、修改
			dtsEdit() {
                const _this = this;

                if(!_this.dts_edit_form.options.A || !_this.dts_edit_form.options.B || !_this.dts_edit_form.options.C || !_this.dts_edit_form.options.D) {
                    layer.msg('请输入答题卡选项内容')
                    return false
                }
                let data = {
                    "header": Vue.request_header,
					"request": {
						"param": {
                            "theme_id": _this.dts_edit_form.theme_id,
							"name": _this.dts_edit_form.name,
                            "question": _this.dts_edit_form.question,
                            "answer": _this.dts_edit_form.answer,
                            "options": {
                                A: _this.dts_edit_form.options.A,
                                B: _this.dts_edit_form.options.B,
                                C: _this.dts_edit_form.options.C,
                                D: _this.dts_edit_form.options.D
                            }
						}
					},
					"comment": ""
                };
                if(_this.dts_edit_id) {
                    data.request.param.id = _this.dts_edit_id;
                }
                Vue.axios({
					method: 'post',
					url: 'BistroLevels/addQuestion',
					data: data
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						layer.msg('操作成功');
						_this.getDtsTable(_this.dts_page);
						_this.showDtsEdit = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
            },



            /*
             * 关卡设置
             */
            // 更改门店
            gksListShop(val) {
                new Promise(resolve => {
                    this.getShopTheme(val, 'gks_list', resolve)
                })
            },
            gksEditShop(val) {
                new Promise(resolve => {
                    this.getShopTheme(val, 'gks_edit', resolve)
                })
            },
            // 列表
			getGksTable: function(page) {
				const _this = this;

				_this.loading = true;
				Vue.axios.post('BistroLevels/getLevelsList', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
                            "page_size": _this.GLOBAL.PAGESIZE,
                            "shop_id": _this.gks_list_form.shop_id,
                            "theme_id": _this.gks_list_form.theme_id,
                            "name": _this.gks_list_form.name
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
                            _this.gks_total = Number(res.data.response.result.count)
                            _this.gks_page = 1
						}
						_this.gks_table = res.data.response.result.data;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
            },
            // 删除
			gksDel(id) {
				const _this = this;

				layer.confirm('删除后不可恢复，确定删除吗？', {
					btn: ['确定', '取消']
				}, function() {
					Vue.axios.post('BistroLevels/delLevel', {
						"header": Vue.request_header,
						"request": {
							"version": Vue.version,
							"param": {
								"id": id
							}
						},
						"comment": ""
					})
					.then(res => {
						if(res.data.response.result_code == "true") {
							layer.msg('删除成功');
							_this.getGksTable(_this.gks_page);
						} else {
							Vue.timeoutfun(res.data.response.result_status, _this);
							layer.msg(res.data.response.error_msg);
						}
					})
					.catch(err => {
						layer.msg('出错啦');
					});
				});
            },
            // 关卡二维码
            gksQrcode(row) {
                const src = new QRCode('gksRowQrcode', {
			        width: 200,
			        height: 200,
			        text: row.qrcode // 设置二维码内容或跳转地址
                })
                this.gks_row_qrcode = src
                this.gks_row_name = row.name
                layer.open({
					type: 1,
					title: '关卡二维码',
					skin: 'public-alert-skin',
					area: ['500px', ''],
                    content: $(this.$refs.gks_qrcode_alert),
                    cancel: function() {
                        document.getElementById("gksRowQrcode").innerHTML = "";
                    }
				})
            },
            // 下载二维码
            gksRowDl() {
                const myCanvas = document.getElementById("gksRowQrcode").getElementsByTagName("canvas");
                let a = document.createElement("a")
                a.href = myCanvas[0].toDataURL("image/png")
                a.download = this.gks_row_name
                a.click()
            },
            // 点击新增
			gksAdd() {
                this.gks_edit_id = ''
                this.gks_edit_tit = '新增关卡'
                this.gks_edit_form = {
                    shop_id: this.shop_list[0].id,
                    no: '',
                    name: '',
                    theme_id: '',
                    theme_story_line_id: '',
                    type: '',
                    example_img: require('../../assets/images/upload_btn.png'),
                    example_img_done: false,
                    theme_question_id: '',
                    clock_in: '1',
                    coordinate: {
                        x: '',
                        y: ''
                    },
                    content: '',
                    img_unfinished: require('../../assets/images/upload_btn.png'),
                    img_unfinished_done: false,
                    img_current: require('../../assets/images/upload_btn.png'),
                    img_current_done: false,
                    img_finished: require('../../assets/images/upload_btn.png'),
                    img_finished_done: false
                }
                new Promise(resolve => {
                    this.getShopTheme(this.shop_list[0].id, 'gks_edit', resolve)
                })
                .then(res => {
                    this.gks_edit_form.theme_id = this.gks_edit_theme[0].theme_id
                    new Promise(resolve => {
                        this.getThemeStory(this.gks_edit_form.theme_id, resolve);
                    })
                    new Promise(resolve => {
                        this.getThemeQuestion(this.gks_edit_form.theme_id, resolve);
                    })
                })
                this.showGksEdit = true;
			},
			// 点击修改
			gksModify(row) {
                this.gks_edit_id = row.id
				this.gks_edit_tit = '修改关卡'
                this.gks_edit_form = {
                    shop_id: row.shop_id,
                    no: row.no,
                    name: row.name,
                    theme_id: '',
                    theme_story_line_id: '',
                    type: row.type,
                    example_img: require('../../assets/images/upload_btn.png'),
                    example_img_done: false,
                    theme_question_id: '',
                    clock_in: row.clock_in,
                    coordinate: {
                        x: row.coordinate.x,
                        y: row.coordinate.y
                    },
                    content: row.content,
                    img_unfinished: row.img_unfinished,
                    img_unfinished_done: true,
                    img_current: row.img_current,
                    img_current_done: true,
                    img_finished: row.img_finished,
                    img_finished_done: true,
                }
                new Promise(resolve => {
                    this.getShopTheme(this.gks_edit_form.shop_id, 'gks_edit', resolve)
                })
                this.gks_edit_form.theme_id = row.theme_id
                new Promise(resolve => {
					this.getThemeStory(this.gks_edit_form.theme_id, resolve);
                })
                this.gks_edit_form.theme_story_line_id = row.theme_story_line_id;
                new Promise(resolve => {
                    this.getThemeQuestion(this.gks_edit_form.theme_id, resolve);
                })
                if(row.type == '1') {
                    this.gks_edit_form.example_img = row.example_img
                    this.gks_edit_form.example_img_done = true;
                } else if(row.type == '2') {
                    this.gks_edit_form.theme_question_id = row.theme_question_id
                }
                this.showGksEdit = true;
            },
            // 更改主题
            gksThemeChange(val) {
                this.gks_edit_form.theme_story_line_id = ''
                this.gks_edit_form.theme_question_id = ''
                new Promise(resolve => {
					this.getThemeStory(val, resolve)
                })
                new Promise(resolve => {
                    this.getThemeQuestion(val, resolve);
                })
            },
            // 关卡图片
			gksImgUpload: function(id) {
				let _this = this;
				let host = '',
					dir = '',
					file_name = '';

				setTimeout(function() {
					// 实例化一个plupload上传对象
					let uploader = new plupload.Uploader({
						browse_button: id, // 选择文件id
						filters: {
							mime_types: [ // 文件格式限制
								{ title: "Image files", extensions: "jpg,jpeg,png,gif" }
							],
							// max_file_size: '2mb', // 文件大小限制
							// prevent_duplicates: true // 不允许选取重复文件
						},
						// resize: {
						// 	width: 527,
						// 	height: 296
						// },
						multi_selection: false, // 单选
						url: './', // OSS地址
						init: {
							// 文件上传前触发
							BeforeUpload: function(up, file) {},
							// 文件选择完毕触发
							FilesAdded: function(up, files) {
								// 获取签名
								Vue.axios.post('publicData/api_getOssSignature', {
									"header": Vue.request_header,
									"request": {
										"version": Vue.version,
										"param": {
											"file": files[0].name,
											"path": 'ticket_system'
										}
									},
									"comment": ""
								})
								.then(res => {
									if(res.data.response.result_code == "true") {
										host = res.data.response.data.host;
										dir = res.data.response.data.dir;
										file_name = res.data.response.data.file_name;
										const new_params = {
											'key': dir + file_name,
											'OSSAccessKeyId': res.data.response.data.accessid,
											'policy': res.data.response.data.policy,
											'signature': res.data.response.data.signature,
											'success_action_status': '200', // 让服务端返回200，不然，默认会返回204
										};
										up.setOption({
											'url': host,
											'multipart_params': new_params
										});

										// 上传文件
										uploader.start();
									} else {
										Vue.timeoutfun(data.response.result_status, _this);
										layer.msg(data.response.error_msg);
									}
								})
								.catch(err => {
									layer.msg("出错啦");
								});
							},
							// 文件上传成功触发
							FileUploaded: function(up, file, data) {
                                if(id == 'gksExampleImg') {
                                    _this.gks_edit_form.example_img = host + "/" + dir + file_name;
								    _this.gks_edit_form.example_img_done = true;
                                } else if(id == 'gksPreImg') {
                                    _this.gks_edit_form.img_unfinished = host + "/" + dir + file_name;
								    _this.gks_edit_form.img_unfinished_done = true;
                                } else if(id == 'gksNowImg') {
                                    _this.gks_edit_form.img_current = host + "/" + dir + file_name;
								    _this.gks_edit_form.img_current_done = true;
                                } else if(id == 'gksDoneImg') {
                                    _this.gks_edit_form.img_finished = host + "/" + dir + file_name;
								    _this.gks_edit_form.img_finished_done = true;
                                }
								layer.msg('上传成功');
							},
							// 错误提示
							Error: function(up, err) {
								if(err.code == -600) {
									layer.msg('请选择2mb以内的文件');
								} else if (err.code == -601) {
									layer.msg('只允许上传jpg,jpeg,png,gif文件');
								} else if (err.code == -602) {
									layer.msg('这个文件已经上传过一遍了');
								} else {
									layer.msg(err.response);
								}
							}
						}
					});
					// 初始化
					uploader.init();
				}, 20);
            },
            // 新增、修改
			gksEdit() {
                const _this = this;

                let example_img = '',
                    theme_question_id = ''
                if(!_this.gks_edit_form.type) {
                    layer.msg('请选择闯关类型')
                    return false
                } else if(_this.gks_edit_form.type == '1') {
                    if(_this.gks_edit_form.example_img_done) {
                        example_img = _this.gks_edit_form.example_img
                    } else {
                        layer.msg('请上传拍照示例图')
                        return false
                    }
                } else if(_this.gks_edit_form.type == '2') {
                    if(_this.gks_edit_form.theme_question_id) {
                        theme_question_id = _this.gks_edit_form.theme_question_id
                    } else {
                        layer.msg('请选择答题卡名称')
                        return false
                    }
                }
                if(_this.gks_edit_form.coordinate.x == '' || _this.gks_edit_form.coordinate.y == '') {
                    layer.msg('请输入关卡地图坐标')
                    return false
                }
                let img_unfinished = '',
                    img_current = '',
                    img_finished = ''
                if(_this.gks_edit_form.img_unfinished_done && _this.gks_edit_form.img_current_done && _this.gks_edit_form.img_finished_done) {
                    img_unfinished = _this.gks_edit_form.img_unfinished
                    img_current = _this.gks_edit_form.img_current
                    img_finished = _this.gks_edit_form.img_finished
                } else {
                    layer.msg('请上传关卡图片')
                    return false
                }
                let data = {
                    "header": Vue.request_header,
					"request": {
						"param": {
                            "shop_id": _this.gks_edit_form.shop_id,
                            "no": _this.gks_edit_form.no,
                            "name": _this.gks_edit_form.name,
                            "theme_id": _this.gks_edit_form.theme_id,
                            "theme_story_line_id": _this.gks_edit_form.theme_story_line_id,
                            "type": _this.gks_edit_form.type,
                            "example_img": example_img,
                            "theme_question_id": theme_question_id,
                            "clock_in": _this.gks_edit_form.clock_in,
                            "coordinate": {
                                "x": _this.gks_edit_form.coordinate.x,
                                "y": _this.gks_edit_form.coordinate.y
                            },
                            "content": _this.gks_edit_form.content,
                            "img_unfinished": img_unfinished,
                            "img_current": img_current,
                            "img_finished": img_finished
						}
					},
					"comment": ""
                };
                if(_this.gks_edit_id) {
                    data.request.param.id = _this.gks_edit_id;
                }
                Vue.axios({
					method: 'post',
					url: 'BistroLevels/addLevels',
					data: data
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						layer.msg('操作成功');
						_this.getGksTable(_this.gks_page);
						_this.showGksEdit = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
            },



            /*
             * 闯关奖励规则设置
             */
            // 更改门店
            cjgListShop(val) {
                new Promise(resolve => {
                    this.getShopTheme(val, 'cjg_list', resolve)
                })
            },
            cjgEditShop(val) {
                new Promise(resolve => {
                    this.getShopTheme(val, 'cjg_edit', resolve)
                })
            },
            // 列表
			getCjgTable: function(page) {
				const _this = this;

				_this.loading = true;
				Vue.axios.post('BistroLevels/getLevelsRewardsRuleList', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
                            "page_size": _this.GLOBAL.PAGESIZE,
                            "shop_id": _this.cjg_list_form.shop_id,
                            "name": _this.cjg_list_form.name,
                            "type": _this.cjg_list_form.type,
                            "theme_id": _this.cjg_list_form.theme_id
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
                            _this.cjg_total = Number(res.data.response.result.count)
                            _this.cjg_page = 1
						}
						_this.cjg_table = res.data.response.result.data;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
            },
            // 删除
			cjgDel(row) {
				const _this = this;

				layer.confirm('删除后不可恢复，确定删除吗？', {
					btn: ['确定', '取消']
				}, function() {
					Vue.axios.post('BistroLevels/delLevelRewardsRule', {
						"header": Vue.request_header,
						"request": {
							"version": Vue.version,
							"param": {
                                "id": row.id,
                                "shop_id": row.shop_id
							}
						},
						"comment": ""
					})
					.then(res => {
						if(res.data.response.result_code == "true") {
							layer.msg('删除成功');
							_this.getCjgTable(_this.cjg_page);
						} else {
							Vue.timeoutfun(res.data.response.result_status, _this);
							layer.msg(res.data.response.error_msg);
						}
					})
					.catch(err => {
						layer.msg('出错啦');
					});
				});
            },
            // 点击新增
			cjgAdd() {
                this.cjg_edit_id = ''
                this.cjg_edit_tit = '新增闯关奖励规则'
                this.cjg_edit_form = {
                    shop_id: this.shop_list[0].id,
                    name: '',
                    theme_id: '',
                    levels_count: '',
                    type: '1',
                    goods: [{
                        name: '',
                        probability: '',
                        img: require('../../assets/images/upload_btn.png'),
                        img_id: 'cjgImg0',
                        img_done: false,
                        infos: []
                    }, {
                        name: '',
                        probability: '',
                        img: require('../../assets/images/upload_btn.png'),
                        img_id: 'cjgImg1',
                        img_done: false,
                        infos: []
                    }, {
                        name: '',
                        probability: '',
                        img: require('../../assets/images/upload_btn.png'),
                        img_id: 'cjgImg2',
                        img_done: false,
                        infos: []
                    }]
                }
                new Promise(resolve => {
                    this.getShopTheme(this.shop_list[0].id, 'cjg_edit', resolve)
                })
                this.showCjgEdit = true;
			},
			// 点击修改
			cjgModify(id) {
                const _this = this;

                Vue.axios.post('BistroLevels/getLevelsRewardsRuleDetail', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "id": id
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        const row = res.data.response.result;

                        _this.cjg_edit_id = row.id
                        _this.cjg_edit_tit = '修改闯关奖励规则'
                        _this.cjg_edit_form = {
                            shop_id: row.shop_id,
                            name: row.name,
                            theme_id: '',
                            levels_count: row.levels_count,
                            type: row.type,
                            goods: []
                        }
                        row.goods.forEach((item, index) => {
                            _this.cjg_edit_form.goods.push({
                                name: item.name,
                                probability: item.probability,
                                img: item.img,
                                img_id: 'cjgImg' + index,
                                img_done: true,
                                infos: item.infos
                            })
                        })
                        new Promise(resolve => {
                            _this.getShopTheme(row.shop_id, 'cjg_edit', resolve)
                        })
                        _this.cjg_edit_form.theme_id = row.theme_id
                        _this.showCjgEdit = true;
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },
            // 奖品图片
			cjgImgUpload: function(id, index) {
				let _this = this;
				let host = '',
					dir = '',
					file_name = '';

				setTimeout(function() {
					// 实例化一个plupload上传对象
					let uploader = new plupload.Uploader({
						browse_button: id, // 选择文件id
						filters: {
							mime_types: [ // 文件格式限制
								{ title: "Image files", extensions: "jpg,jpeg,png,gif" }
							],
							// max_file_size: '2mb', // 文件大小限制
							// prevent_duplicates: true // 不允许选取重复文件
						},
						// resize: {
						// 	width: 527,
						// 	height: 296
						// },
						multi_selection: false, // 单选
						url: './', // OSS地址
						init: {
							// 文件上传前触发
							BeforeUpload: function(up, file) {},
							// 文件选择完毕触发
							FilesAdded: function(up, files) {
								// 获取签名
								Vue.axios.post('publicData/api_getOssSignature', {
									"header": Vue.request_header,
									"request": {
										"version": Vue.version,
										"param": {
											"file": files[0].name,
											"path": 'ticket_system'
										}
									},
									"comment": ""
								})
								.then(res => {
									if(res.data.response.result_code == "true") {
										host = res.data.response.data.host;
										dir = res.data.response.data.dir;
										file_name = res.data.response.data.file_name;
										const new_params = {
											'key': dir + file_name,
											'OSSAccessKeyId': res.data.response.data.accessid,
											'policy': res.data.response.data.policy,
											'signature': res.data.response.data.signature,
											'success_action_status': '200', // 让服务端返回200，不然，默认会返回204
										};
										up.setOption({
											'url': host,
											'multipart_params': new_params
										});

										// 上传文件
										uploader.start();
									} else {
										Vue.timeoutfun(data.response.result_status, _this);
										layer.msg(data.response.error_msg);
									}
								})
								.catch(err => {
									layer.msg("出错啦");
								});
							},
							// 文件上传成功触发
							FileUploaded: function(up, file, data) {
                                _this.cjg_edit_form.goods[index].img = host + "/" + dir + file_name;
								_this.cjg_edit_form.goods[index].img_done = true;
							},
							// 错误提示
							Error: function(up, err) {
								if(err.code == -600) {
									layer.msg('请选择2mb以内的文件');
								} else if (err.code == -601) {
									layer.msg('只允许上传jpg,jpeg,png,gif文件');
								} else if (err.code == -602) {
									layer.msg('这个文件已经上传过一遍了');
								} else {
									layer.msg(err.response);
								}
							}
						}
					});
					// 初始化
					uploader.init();
				}, 20);
            },
            // 添加奖品
			cjgPrizesAdd: function(index) {
				const _this = this;

				_this.coupon_type = ''
				_this.coupon_name = ''
				_this.coupon_page = 1
				_this.getCouponTable(1)
				layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['添加活动券', true],
                    area: ['700px', '500px'], // 宽高
                    content: $(_this.$refs.cjg_coupon_alert)
                }, function() {
                    // 保存活动券
                    _this.coupon_table_select.forEach(_ => {
                        let isTrue = true;
                        for(let i = 0; i < _this.cjg_edit_form.goods[index].infos.length; i++) {
                            if(_this.cjg_edit_form.goods[index].infos[i].gift_id == _.id) {
                                isTrue = false
                                return false
                            }
                        }
                        if(isTrue) {
                            _this.cjg_edit_form.goods[index].infos.push({
                                gift_id: _.id,
                                gift_name: _.name,
                                gift_type: _.type,
                                gift_type_name: _.type_name,
                                quantity: 1
                            })
                        }
                    })
                    layer.msg('保存成功')
                    _this.$refs.coupon_table.clearSelection();
                });
			},
			cjgPrizesDel(i, j) {
				this.cjg_edit_form.goods[i].infos.splice(j, 1)
			},
			couponTypeChange(val) {
				this.getCouponTable(1);
			},
			getCouponTable: function(page) {
				const _this = this;

				_this.loading = true;
                Vue.axios.post('MerchantGift/getListToTicket', {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"page": page,
							"page_size": _this.GLOBAL.PAGESIZEMINI,
							"shop_id": _this.cjg_edit_form.shop_id,
							"type": _this.coupon_type,
							"name": _this.coupon_name
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.coupon_total = Number(res.data.response.result.total);
						}
						_this.coupon_table = res.data.response.result.rows;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
			},
			getCouponSelect(val) {
				this.coupon_table_select = val
            },
            cjgCouponQuantity(val, i, j, quantity) {
                if(!/^[1-9]\d*$/.test(quantity)) {
                    layer.msg('请输入正整数')
                    this.cjg_edit_form.goods[i].infos[j].quantity = 1
                }
            },
            // 新增、修改
			cjgEdit() {
                const _this = this;

                let isTrue = true;
                for(let i = 0; i < _this.cjg_edit_form.goods.length; i++) {
                    if(!_this.cjg_edit_form.goods[i].img_done) {
                        isTrue = false
                    }
                }
                if(!isTrue) {
                    layer.msg('请上传奖品图片')
                    return false
                }
                let data = {
                    "header": Vue.request_header,
					"request": {
						"param": {
                            "shop_id": _this.cjg_edit_form.shop_id,
                            "name": _this.cjg_edit_form.name,
                            "theme_id": _this.cjg_edit_form.theme_id,
                            "levels_count": _this.cjg_edit_form.levels_count,
                            "type": _this.cjg_edit_form.type,
                            "goods": _this.cjg_edit_form.goods
						}
					},
					"comment": ""
                };
                if(_this.cjg_edit_id) {
                    data.request.param.id = _this.cjg_edit_id;
                }
                Vue.axios({
					method: 'post',
					url: 'BistroLevels/addLevelsRewardsRule',
					data: data
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						layer.msg('操作成功');
						_this.getCjgTable(_this.cjg_page);
						_this.showCjgEdit = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
            },



            /*
             * 闯关游戏设置
             */
            // 列表
			getCysTable: function(page) {
				const _this = this;

				_this.loading = true;
				Vue.axios.post('BistroLevels/getShopThemeList', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
                            "page_size": _this.GLOBAL.PAGESIZE,
                            "shop_id": _this.cys_list_form.shop_id
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
                            _this.cys_total = Number(res.data.response.result.count)
                            _this.cys_page = 1
						}
						_this.cys_table = res.data.response.result.data;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
            },
            // 删除
			cysDel(id) {
				const _this = this;

				layer.confirm('删除后不可恢复，确定删除吗？', {
					btn: ['确定', '取消']
				}, function() {
					Vue.axios.post('BistroLevels/delShopTheme', {
						"header": Vue.request_header,
						"request": {
							"version": Vue.version,
							"param": {
                                "id": id
							}
						},
						"comment": ""
					})
					.then(res => {
						if(res.data.response.result_code == "true") {
							layer.msg('删除成功');
							_this.getCysTable(_this.cys_page);
						} else {
							Vue.timeoutfun(res.data.response.result_status, _this);
							layer.msg(res.data.response.error_msg);
						}
					})
					.catch(err => {
						layer.msg('出错啦');
					});
				});
            },
            // 启用、禁用
            cysStatus(id) {
				const _this = this;

				layer.confirm('确定执行操作吗？', {
					btn: ['确定', '取消']
				}, function() {
					Vue.axios.post('BistroLevels/setShopThemeStatus', {
						"header": Vue.request_header,
						"request": {
							"version": Vue.version,
							"param": {
                                "id": id
							}
						},
						"comment": ""
					})
					.then(res => {
						if(res.data.response.result_code == "true") {
							layer.msg('操作成功');
							_this.getCysTable(_this.cys_page);
						} else {
							Vue.timeoutfun(res.data.response.result_status, _this);
							layer.msg(res.data.response.error_msg);
						}
					})
					.catch(err => {
						layer.msg('出错啦');
					});
				});
            },
            // 复制链接
            cysCopy(url) {
                const input = document.createElement('input')
                input.setAttribute('readonly', 'readonly')
                input.setAttribute('value', url)
                document.body.appendChild(input)
                input.setSelectionRange(0, 9999)
				input.select()
                if(document.execCommand('copy')) {
                    document.execCommand('copy')
                    layer.msg('复制成功')
                }
                document.body.removeChild(input)
            },
            // 点击新增
			cysAdd() {
                this.cys_edit_id = ''
                this.cys_edit_tit = '新增闯关游戏'
                this.cys_edit_form = {
                    shop_id: this.shop_list[0].id,
                    theme_id: '',
                    listorder: '',
                    get_location: ''
                }
                this.showCysEdit = true
			},
			// 点击修改
			cysModify(row) {
                const _this = this;

                _this.cys_edit_id = row.id
                _this.cys_edit_tit = '修改闯关游戏'
                _this.cys_edit_form = {
                    shop_id: row.shop_id,
                    theme_id: row.theme_id,
                    listorder: row.listorder,
                    get_location: row.get_location
                }
                _this.showCysEdit = true
            },
            // 新增、修改
			cysEdit() {
                const _this = this;

                let url = 'BistroLevels/addShopTheme'
                let data = {
                    "header": Vue.request_header,
					"request": {
						"param": {
                            "shop_id": _this.cys_edit_form.shop_id,
                            "theme_id": _this.cys_edit_form.theme_id,
                            "listorder": _this.cys_edit_form.listorder,
                            "get_location": _this.cys_edit_form.get_location
						}
					},
					"comment": ""
                };
                if(_this.cys_edit_id) {
                    url = 'BistroLevels/editShopTheme'
                    data.request.param.id = _this.cys_edit_id
                }
                Vue.axios({
					method: 'post',
					url: url,
					data: data
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						layer.msg('操作成功');
						_this.getCysTable(_this.cys_page);
						_this.showCysEdit = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
            },
        }
    }
</script>
<style lang="less">
    .level-manage {
        .list-tit {
            span {
                width: 100%;
                border: 1px solid #CCC;
                margin: 0 0 30px;
                line-height: 50px;
                font-size: 16px;
                text-align: center;
                cursor: pointer;
                border-radius: 10px;
            }
        }
        h1 {
            text-align: center;
        }
        p {
            color: #ff2e2e;
        }
        .select-goods-wrap {
            display: none;
        }
    }

    .el-table {
        margin-top: 20px !important;
    }

    .zls-edit {
        .el-form {
            .el-input {
                width: 400px;
                margin-right: 15px;
            }
            .el-textarea {
                width: 400px;
            }
            .el-row {
                margin: 15px 0;
            }
            img {
                display: inline-block;
                width: 114px;
                height: 114px;
                margin-right: 15px;
                cursor: pointer;
            }
            i {
                color: #409eff;
                font-size: 40px;
                vertical-align: bottom;
                cursor: pointer;
            }
		}
    }
    .jqs-edit {
        .el-form {
            .el-select {
                width: 400px;
                margin-right: 15px;
            }
            .el-input {
                width: 400px;
                margin-right: 15px;
            }
            .jqs-input-mini {
                width: 360px;
                .el-input {
                    width: 360px;
                }
            }
            i {
                color: #409eff;
                font-size: 40px;
                vertical-align: bottom;
                cursor: pointer;
            }
            .el-row {
                margin-bottom: 15px;
            }
		}
    }
    .dts-edit {
        .el-form {
            .el-select {
                width: 400px;
            }
            .el-input {
                width: 400px;
            }
            .el-row {
                margin-bottom: 15px;
            }
		}
    }
    .gks-edit {
        .el-form {
            .el-select {
                width: 400px;
            }
            .el-input {
                width: 400px;
            }
            .el-textarea {
                width: 400px;
            }
            img {
                display: block;
                width: 114px;
                height: 114px;
                cursor: pointer;
            }
            .gks-input-mini {
                width: 168px;
            }
            .el-row {
                margin-top: 15px;
            }
            .gks-edit-row {
                width: 420px;
                margin-top: 0;
                dd {
                    width: 114px;
                    margin: 10px 0 0;
                    text-align: center;
                }
            }
		}
    }
    .gks-qrcode-alert {
        display: none;
        .gks-row-qrcode {
            width: 200px;
            margin: 0 auto 20px;
        }
        p {
            text-align: center;
        }
        .el-row {
            text-align: center;
        }
    }
    .cjg-edit {
        .el-form {
            .el-select {
                width: 400px;
            }
            .el-input {
                width: 400px;
            }
            .el-row {
                margin-bottom: 15px;
            }
            .cjg-table-input {
                width: 160px;
            }
            .cjg-edit-row {
                width: 500px;
                .cjg-input-normal {
                    width: 160px;
                }
                .cjg-input-mini {
                    width: 83px;
                }
                i {
                    color: #409eff;
                    font-size: 40px;
                    vertical-align: bottom;
                    cursor: pointer;
                }
            }
            img {
                float: left;
                width: 114px;
                height: 114px;
                margin: 0 15px 0 0;
                cursor: pointer;
            }
		}
    }
    .cys-edit {
        .el-form {
            .el-select {
                width: 400px;
            }
            .el-input {
                width: 400px;
            }
		}
    }
</style>